var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebinars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.321,
    height: 23.156,
    viewBox: "0 0 26.321 23.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.5 -14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,17.374A2.373,2.373,0,0,1,12.374,15H32.948a2.374,2.374,0,0,1,2.374,2.374V34.782a2.374,2.374,0,0,1-2.374,2.374H12.374A2.374,2.374,0,0,1,10,34.782Z",
    fill: "none",
    stroke: "#0080ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.406,28.956A3.956,3.956,0,1,1,41.45,25,3.957,3.957,0,0,1,45.406,28.956Z",
    transform: "translate(-18.792 -6.834)",
    fill: "none",
    stroke: "#0080ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,62.89V55.769a3.115,3.115,0,0,1,3.114-3.116,6.787,6.787,0,0,0,9.595,0h0a3.115,3.115,0,0,1,3.114,3.116V62.89Z",
    transform: "translate(-10.252 -25.734)",
    fill: "none",
    stroke: "#0080ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.248,76.454v0Z",
    transform: "translate(-17.94 -39.299)",
    fill: "none",
    stroke: "#0080ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.748,72.5v0Z",
    transform: "translate(-36.736 -39.299)",
    fill: "none",
    stroke: "#0080ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/webinars.6f77ed67.svg";
export { ForwardRef as ReactComponent };